import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import { errorsInput } from 'src/consts';
import { useTranslation } from 'react-i18next';
import { SMART_COLIS_TRACKING_SHIPPING_OR_COLIS_PATTERN } from 'src/helpers';

type TrackingColiPublicInput = {
  code: string;
  tracking: string;
};


type TrackingColiPublicDefaultInput = {
  code?: string;
  tracking?: string;
};

export const useTrackingColiPublicForm = (defaultValues:TrackingColiPublicDefaultInput) => {
  const { t } = useTranslation();

  const validationSchema = Yup.object().shape({
    tracking: Yup.string()
      .required(errorsInput.required)
      .matches(SMART_COLIS_TRACKING_SHIPPING_OR_COLIS_PATTERN, t(errorsInput.invalidColiTrackingNumber)),
    code: Yup.string()
      .required(errorsInput.required)
      .matches(/[0-9]{4}/,t(errorsInput.codeSecureColiInvalid))
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const {
    control,
    handleSubmit,
    watch,
    reset,
    formState: { errors },
  } = useForm<TrackingColiPublicInput>({...formOptions, defaultValues});


  const code = watch('code');

  return {
    control,
    handleSubmit,
    reset,
    errors,
    code
  }
};
